import { useSelector } from 'react-redux'
import { FlashList } from "@shopify/flash-list";

import { ActivityIndicator, SafeAreaView, View, StyleSheet, ScrollView, SectionList, Dimensions, Touchable, TouchableOpacity, Linking, StatusBar } from 'react-native';
import { Text, IconButton, Divider, FAB, shadow, TextInput, Button, Chip } from 'react-native-paper';
import * as React from 'react';
import { useTheme } from 'react-native-paper';
import dayjs from 'dayjs';
import Global from '../constants/global';
import Modal from 'react-native-modal';
import { collection, doc, getFirestore, setDoc } from 'firebase/firestore';
import Toast from 'react-native-root-toast';
import ClassRow from '../components/ClassRow';

import DIcon from '../components/DIcon';
import DYear from '../components/DYear';


const cy = Global.getYear()
export default function Arrangements({ navigation, route }) {
    const classList = useSelector((state) => state.list.Classes)
    const classTeacher = useSelector((state) => state.list.ClassTeacher)
    const [sortedClassList, setSortedClassList] = React.useState([])
    const subjectList = useSelector((state) => state.list.Subjects)
    const teachers = useSelector(React.useMemo(Global.getUserList, []))
    const [filteredSubjects, setFIlteredSubjects] = React.useState([])
    const [teacherList, setTeacherList] = React.useState([])
    const [classes, setClass] = React.useState(undefined)
    const [focus, setFocus] = React.useState(undefined)
    const [show, setShow] = React.useState(false)
    const [currentYear, setCY] = React.useState(cy)


    const [focusSubject, setFocusSubject] = React.useState(undefined)

    React.useEffect(() => {
        if (focus) {
            const s: [] = subjectList.filter(e => focus?.year <= 2023 ? e.classid == focus.id : (e.final == true && focus.classNo == e.classNo))
            setFIlteredSubjects(s)
        }
    }, [focus, subjectList])

    React.useEffect(() => {
        if (teachers) {
            const s: [] = teachers.filter(e => (e.retired !== true) && (e.type == Global.PRINCIPAL || e.type == Global.TEACHER || e.type == Global.VISITING_TEACHER))
            setTeacherList(s)
        }
    }, [teachers])

    React.useEffect(() => {
        if (classList) {
            const s: [] = []
            classList.map(p => {
                if (currentYear < 2024 ? p.year == currentYear : p?.final == true) {
                    s.push({ ...p })
                }
            }
            )
            const nnewP = s.sort((a, b) => a?.seq < b?.seq ? -1 : 0)
            setSortedClassList(nnewP)
        }
    }, [classList, currentYear])

    function dismissSubject() {
        setFocusSubject(undefined)
    }

    const { colors } = useTheme();


    return (
        <ScrollView style={{ flex: 1 }}>
            <View style={{ backgroundColor: colors.background, flex: 1, paddingTop: route?.params?.topMargin ? StatusBar.currentHeight : 0 }}>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <TouchableOpacity onPress={() => { setShow(true) }}>
                        <View style={{ flexDirection: "row", alignItems: "center" }}>
                            <Text variant="headlineMedium">Classes   </Text>
                            <Text>{Global.getYearString(currentYear)}</Text>
                            <DIcon name="cog" color='black' />
                        </View>
                    </TouchableOpacity>
                    <View style={{ flex: 1 }}></View>
                    <FAB style={{ alignSelf: "flex-end" }} icon={"plus"} onPress={() => { setClass({ name: "", section: "", div: "" }) }} />
                </View>
                <FlashList
                    data={sortedClassList}
                    key="id"
                    estimatedItemSize={70}
                    keyboardShouldPersistTaps={'handled'}
                    renderItem={({ item, index }) =>
                        <TouchableOpacity onPress={() => {
                            setFocus(item)
                        }}>
                            <ClassRow item={item} />
                        </TouchableOpacity>
                    } />
                {focus !== undefined &&
                    <View style={{ marginTop: 20 }}>
                        <Divider />
                        <Text style={{ marginTop: 20 }} variant="headlineMedium">Select Class Teacher ({focus.name + (focus?.div ? " - " + focus?.div : "")})</Text>

                        <SelectClassTeacher currentYear={currentYear} focus={focus} teacherList={teacherList} classTeacher={classTeacher} />
                        <Divider />

                        <View style={{ flexDirection: "row", marginTop: 20 }}>
                            <Text style={{ flex: 1 }} variant="headlineMedium">Subjects ({focus.name + (focus?.div ? " - " + focus?.div : "")})</Text>
                            <FAB icon={"plus"} onPress={() => { setFocusSubject({ theory: true, name: "", className: focus.name, classid: focus.id }) }} />
                        </View>
                        <FlashList
                            data={filteredSubjects}
                            key="id"
                            estimatedItemSize={70}
                            keyboardShouldPersistTaps={'handled'}
                            renderItem={({ item, index }) =>
                                <TouchableOpacity onPress={() => setFocusSubject(item)}>
                                    <View style={{ flexDirection: "row", paddingLeft: 30 }}>
                                        <Text variant="titleLarge" >{item.name}</Text>
                                        {item.stream !== undefined && <Text> ({Global.STREAM[item.stream]})</Text>}
                                    </View>
                                    <Text style={{ fontSize: 10, marginLeft: 40 }}>{item.teacherName}</Text>
                                    <Divider />
                                </TouchableOpacity>
                            } />
                    </View>}
                <DYear show={show} year={currentYear} close={() => {
                    setShow(false)
                }} change={(yr) => {
                    setCY(yr)
                    setShow(false)
                }} />

                <Modal onBackdropPress={() => setClass(undefined)} isVisible={classes !== undefined} style={{ backgroundColor: colors.surface, margin: 0, position: "absolute", bottom: 0, width: Dimensions.get("window").width }} animationIn="slideInUp" >
                    <View>
                        <TextInput label={"Standard"} value={classes?.name} onChangeText={(t) => setClass(p => ({ ...p, name: t }))} />

                        <TextInput label={"Division (Optional)"} value={classes?.div} onChangeText={(t) => setClass(p => ({ ...p, div: t }))} />

                        <ScrollView horizontal style={{ marginTop: 10 }}>
                            <Text>Section :</Text>
                            {Global.SECTIONS.map((e, i) =>
                                <Chip key={i + "s"} selected={classes?.section == i} onPress={() => setClass(p => ({ ...p, section: i }))}>{e}</Chip>
                            )}
                        </ScrollView>

                        <Text style={{ marginTop: 20 }}>Select Class Teacher  :</Text>
                        <View style={{ flexDirection: "row", justifyContent: "center", flexWrap: "wrap" }}>
                            {teacherList.map((e, i) =>
                                <Chip id={i + ""} style={{ margin: 2 }} selected={focus?.classTeacher == e.id} onPress={() => setClass(p => ({ ...p, classTeacher: e.id, classTeacherName: e.name }))}>{e.name}</Chip>
                            )}
                        </View>

                        <View style={{ flexDirection: "row", padding: 10, backgroundColor: "transparent", alignSelf: "stretch" }}>
                            <Button style={{ flex: 1 }} onPress={() => {
                                setClass(undefined)
                            }}>Cancel</Button>
                            <Button style={{ flex: 1 }} onPress={async () => {
                                const data = { ...classes }
                                if (data.id) {
                                    const db = getFirestore()
                                    let ref
                                    ref = doc(db, "Classes", data.id)

                                    data.stamp = dayjs().unix()
                                    try {
                                        setDoc(ref, { flag: -10 }, { merge: true })
                                        setClass(undefined)
                                        Toast.show("Deleted")
                                    } catch (e) {
                                        //      //console.log("err", e)
                                        Toast.show("Error : saving data. Check internet connection")
                                    }

                                }
                            }}>Delete</Button>
                            <Button mode="contained" style={{ flex: 1 }} onPress={async () => {
                                const db = getFirestore()
                                let ref
                                const data = { ...classes }

                                if (!data.id) {
                                    ref = doc(collection(db, "Classes"))
                                    data.id = ref.id
                                } else {
                                    ref = doc(db, "Classes", data.id)
                                }

                                data.stamp = dayjs().unix()
                                try {
                                    setDoc(ref, data, { merge: true })
                                    setClass(undefined)
                                    Toast.show("Saved")
                                } catch (e) {
                                    //      //console.log("err", e)
                                    Toast.show("Error : saving data. Check internet connection")
                                }

                            }}>Save</Button>
                        </View>
                    </View>
                </Modal >
            </View >
        </ScrollView >
    );


}


const SelectClassTeacher = ({ currentYear, focus, teacherList, classTeacher }) => {
    const arr = useSelector(s => s.list.Arrangement)
    const [classes, setClass] = React.useState(undefined)
    React.useEffect(() => {

        const got = arr.find(f => f.year == currentYear)
        const cl = []
        try {
            Object.keys(got).forEach(function (key) {
                if (key.startsWith("cl" + focus.classNo)) {
                    cl.push(got[key])
                }
            })
            cl?.sort(function (a, b) {
                return a.stamp - b.stamp;
            });
            setClass(cl[0])
        } catch {

        }
    }, [arr, focus])

    return <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
        {teacherList?.map((e, i) => {
            return <Chip id={i + "s"} style={{ margin: 2 }} selected={classes?.teacherId == e.id}
                onPress={() => {
                    Global.save({ currentYear: currentYear, classId: focus.id, examNo: 1, teacherId: e.id, teacherName: e.name }).then(e => {
                        if (e == 1) {
                            alert("Done")
                        } else {
                            alert("Error. Pls Try gain later")
                        }
                    }).catch(e => {
                        alert("Error. Pls Try gain later")
                    })
                }}> {e.name}</Chip>
        }
        )}

    </View >
}